"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Queue = void 0;
class Queue {
    constructor(initialQueueSize) {
        this.enqueueIndex = 0;
        this.dequeueIndex = 0;
        this.initialQueueSize = 0;
        this.queue = new Array(initialQueueSize);
        this.initialQueueSize = initialQueueSize;
    }
    enqueue(item) {
        this.enqueueIndex < this.initialQueueSize
            ? (this.queue[this.enqueueIndex++] = item)
            : ++this.enqueueIndex && this.queue.push(item);
    }
    dequeue() {
        const item = this.queue[this.dequeueIndex++];
        if (this.dequeueIndex === this.enqueueIndex) {
            this.enqueueIndex = 0;
            this.dequeueIndex = 0;
        }
        return item;
    }
    isEmpty() {
        return this.enqueueIndex === 0;
    }
}
exports.Queue = Queue;
//# sourceMappingURL=Queue.js.map